export const BACKDROP_TOKENS = {
  default: {
    backgroundColor: 'rgba(0, 0, 0, 0.3)',
    backdropFilter: 'blur(7px)',
  },
} as const;

export type BackdropTokens = typeof BACKDROP_TOKENS;
export type BackdropTokenKey = keyof BackdropTokens;
export type BackdropTokenValue = BackdropTokens[BackdropTokenKey];
